import { render, staticRenderFns } from "./DiscountCodeNotification.vue?vue&type=template&id=42520222&"
import script from "./DiscountCodeNotification.vue?vue&type=script&lang=js&"
export * from "./DiscountCodeNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports